<template>
  <div class="c-select-options">
    <v-row v-if="hasImages">
      <div
        class="col-lg-4 col-md-6 col-sm-12 d-flex"
        v-for="(option, index) in options"
        :key="index"
      >
        <v-card
          :loading="loading"
          class="mx-auto my-12 flex d-flex flex-column"
          :class="{
            'c-select-options__card__selected': isSelected(option)
          }"
          @click="onClick(option)"
        >
          <img
            class="c-select-options__card-image"
            v-if="option.image"
            :src="option.image"
            height="250"
          />
          <div
            class="c-select-options__card-image-empty"
            v-if="!option.image"
          ></div>
          <v-card-title>{{ option.text }}</v-card-title>
        </v-card>
      </div>
    </v-row>
    <div v-if="!hasImages">
      <button
        class="btn c-select-options__btn"
        :class="{
          'btn-primary': isSelected(option),
          'btn-outline-primary': isDefault(option)
        }"
        v-for="(option, index) in options"
        :key="index"
        @click="onClick(option)"
      >
        {{ option.text }}
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectOption",
  props: ["options", "question", "type"],
  computed: {
    hasImages() {
      return this.options.some(option => option.image);
    }
  },
  methods: {
    isSelected(option) {
      if (this.type === "multi-select") {
        return this.question.answer.includes(option.id);
      }
      return this.question.answer === option.id;
    },
    isDefault(option) {
      if (this.type === "multi-select") {
        return !this.question.answer.includes(option.id);
      }
      return this.question.answer !== option.id;
    },
    onClick(option) {
      if (this.type === "multi-select") {
        const isAnswer = this.question.answer.includes(option.id);
        if (isAnswer) {
          const arr = this.question.answer.filter(el => el !== option.id);
          this.$emit("input", arr);
        } else {
          const arr = [...this.question.answer, option.id];
          this.$emit("input", arr);
        }
        return;
      }
      this.$emit("input", option.id);
      return;
    }
  }
};
</script>

<style lang="scss" scoped>
.c-select-options__btn {
  display: block;
  width: 100%;
  margin-bottom: 10px;
  white-space: revert;
}
.c-select-options__card-image {
  width: 100%;
  object-fit: cover;
}
.c-select-options__card-image-empty {
  height: 250px;
  background-color: var(--secondary);
}
.c-select-options__card__selected {
  background-color: #d6d6d6 !important;
}
</style>
